import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={16} cy={16} r={16} fill="url(#bell_svg__a)" />
    <path
      d="M8.626 16.652c-.288.958 2.054 2.62 4.757 3.715a18.29 18.29 0 0 0 1.603.566c.757.227 1.566.41 2.367.544 2.685.447 5.283.338 5.548-.544.441-1.472-2.282-1.69-1.666-5.524.617-3.835-.294-6.088-2.439-6.73-2.144-.644-4.002.936-5.819 4.253-1.816 3.318-3.91 2.248-4.351 3.72Zm8.326 6.885a2.26 2.26 0 0 1-2.042 1.26c-1.363.006-2.479-1.23-2.336-2.532 1.088.524 2.866 1.142 4.378 1.272Z"
      fill="#fff"
    />
    <path
      d="M18.796 8.678c-2.144-.643-4.002.937-5.819 4.254-1.816 3.318-3.91 2.248-4.351 3.72-.288.958 2.054 2.62 4.757 3.715a18.29 18.29 0 0 0 1.603.566c.757.227 1.566.41 2.367.544 2.685.447 5.283.338 5.548-.544.441-1.472-2.282-1.69-1.666-5.524.617-3.835-.294-6.088-2.439-6.73Zm0 0 .48-1.635M14.91 24.797a2.26 2.26 0 0 0 2.042-1.26c-1.512-.13-3.29-.748-4.378-1.272-.143 1.302.973 2.538 2.336 2.532Z"
      stroke="#fff"
    />
    <defs>
      <linearGradient
        id="bell_svg__a"
        x1={16}
        y1={32}
        x2={16}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#27E4D6" />
        <stop offset={0.178} stopColor="#15C1C6" />
        <stop offset={0.371} stopColor="#2E90EA" />
        <stop offset={0.574} stopColor="#776CF2" />
        <stop offset={0.798} stopColor="#995EE3" />
        <stop offset={1} stopColor="#CB47D1" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgBell);
export default Memo;
